function get_test() {
    // 1 花乐值 2 测试 3 白票魔王 4绿城饭票 5.申龙彪 7.员工站1
    return 1;
}

function str_isnull(str) {
    if (typeof str === 'string') {
        if (str == null || str == undefined || str == "" || str == 'undefined') {
            return true;
        }
        return false;
    }

    if (typeof str === 'number') {
        if (str == null || str == undefined) {
            return true;
        }
        return false;
    }

    if (str == null || str == undefined || str == "" || str.length <= 0) {
        return true;
    }
    return false;
}

function trim(str) { //删除左右两端的空格
    return str.replace(/(^\s*)|(\s*$)/g, "");
}

function get_domain() {
    var domain = '';
    switch (get_test()) {
        case 1:
            domain = '//new.hualezhi.cn/applet.php';
            break;
        case 2:
            domain = 'http://new.hualezhi.cn/applet.php';
            break;
        case 3:
            domain = 'http://bpwx.hualezhi.com/applet.php';
            break;
        case 4:
            domain = 'http://szjiuzhou.top/applet.php';
            break;
        case 5:
            domain = 'http://hlz.phphut.net/applet.php';
            break;
        case 6:
            domain = 'http://hlz.phphut.net/applet.php';
            break;
        case 7:
            domain = 'http://houtai.hualzhi.cn/applet.php';
            break;
    }
    return domain;
}

function get_url_wz() {
    var domain = '';
    switch (get_test()) {
        case 1:
            // domain = 'http://hlzvue.hualezhi.cn/';
            // domain = 'https://shitan.xiaoningbc.cn/';
            domain = 'https://new.hualezhi.xin/';
            break;
        case 2:
            domain = 'http://nek.hualzhi.cn/';

            break;
        case 3:
            domain = 'http://bpwxvue.hualezhi.cn/';
            break;
        case 4:
            domain = 'http://lcvue.hualezhi.cn/';//'http://vue.szjiuzhou.top/';
            break;
        case 5:
            domain = 'http://127.0.0.1:8080/';
            break;
        case 6:
            domain = 'http://hlzvue.phphut.net/';
            break;
        case 7:
            domain = 'http://houtai.hualzhi.cn/';
            break;
    }
    return domain;
}

function is_login() {
    var myToken = localStorage.getItem('myToken');
    if (str_isnull(myToken)) {
        return false;
    }
    return true;
}

function get_appid() {
    var text = '';
    switch (get_test()) {
        case 1:
            text = 'wx6dcaf0a2aaf42a04';
            break;
        case 2:
            text = 'wx6dcaf0a2aaf42a04';
            break;
        case 3:
            text = 'wxc8583ac00676c723';
            break;
        case 4:
            text = 'wx6540f555a4c1e1ce';
            break;
        case 5:
            text = 'wx061372d512d9697c';
            break;
        case 6:
            text = 'wx061372d512d9697c';
            break;
        case 7:
            text = 'wx5bbe9b75a12a876f';
            break;
    }
    return text;
}

function get_unique_id() {
    var text = '';
    switch (get_test()) {
        case 1:
            text = 'gaus0xcyuh';
            break;
        case 2:
            text = 'gaus0xcyuh';
            break;
        case 3:
            text = 'gaus0xcyus';
            break;
        case 4:
            text = 'gaus0xcyus';
            break;
        case 5:
            text = 'gaus0xcyuh';
            break;
        case 6:
            text = 'gaus0xcyuh';
            break;
        case 7:
            text = 'gaus0xcyuh';
            break;
    }
    return text;
}

function go_get_code(url) {
    //var url=get_url_wz();
    url = encodeURIComponent(url);
    var appid = get_appid();
    window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + url + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
    return;
}

function phone_check(phone) {
    if (!(/^1[34578]\d{9}$/.test(phone))) {
        return false;
    }
    return true;
}

function go_pay() {
    try {
        window.location.herf = get_url_wz() + '/pages/waimai_list/wxpay/wxpay?timestamp=' + ((new Date()).getTime() + Math.random());
    } catch (e) {
        //TODO handle the exception
        uni.showModal({
            title: '温馨提示',
            content: JSON.stringify(e),
            showCancel: false,
            confirmText: '我知道了',
            success: function (res) {
            }
        });
    }

}

function getUrlCode() { // 截取url中的code方法
    var url = location.search
    var theRequest = new Object()
    if (url.indexOf("?") != -1) {
        var str = url.substr(1)
        var strs = str.split("&")
        for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1])
        }
    }
    url = window.location.href;
    if (url.indexOf("#") != -1) {
        var dz_url = url.split('#')[1];
        if (dz_url.indexOf("?") != -1) {
            var cs = dz_url.split('?')[1];
            var cs_arr = cs.split('&');
            for (var i = 0; i < cs_arr.length; i++) {
                theRequest[cs_arr[i].split("=")[0]] = (cs_arr[i].split("=")[1])
            }
        }
    }
    console.log(theRequest)
    return theRequest
}


export default {
    str_isnull,
    trim,
    is_login,
    go_get_code,
    get_url_wz,
    phone_check,
    go_pay,
    get_domain,
    get_test,
    get_appid,
    get_unique_id,
    getUrlCode,
}



// WEBPACK FOOTER //
// ./src/common/common.js